import React, { useEffect, useRef } from 'react'
import ReactQuill from 'react-quill-new'
import MarkdownShortcuts from 'quilljs-markdown'

// Restricted toolbar that only shows necessary formatting options
const modules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }], // Headers
        ['bold'], // Bold
        [{ list: 'ordered' }, { list: 'bullet' }], // Lists
        ['clean'], // Remove formatting
    ],
}

const MarkdownEditor = ({ value, onChange, readOnly, placeholder }) => {
    const ref = useRef(null)

    useEffect(() => {
        // Initialize markdown shortcuts when the Quill editor is ready
        if (ref.current) {
            const quill = ref.current.getEditor()
            
            // Initialize quilljs-markdown with only the allowed tags
            new MarkdownShortcuts(quill, {
                // We'll only allow these specific tags
                // By setting specific patterns for some tags and ignoring others
                tags: {
                    // Only including what we want: headers, bold, and lists
                    // Everything else will be ignored by default
                },
                ignoreTags: [
                    'italic', 'strike', 'blockquote', 'code', 'code-block', 
                    'link', 'image', 'script', 'underline', 'formula'
                ]
            })
        }
    }, [])

    useEffect(() => {
        const handleKeyDown = e => {
            // Example: Ctrl+M to blur
            if (e.ctrlKey && e.key === 'm') {
                ref.current?.blur()
            }
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [])

    return (
        <ReactQuill
            ref={ref}
            theme='snow'
            value={value}
            onChange={onChange}
            modules={modules}
            placeholder={placeholder || 'Format using # for headings, ** for bold, and - or 1. for lists'}
            readOnly={readOnly}
        />
    )
}

export default MarkdownEditor 